import { createAction } from '@reduxjs/toolkit';

export const expiredAction = createAction('expiredAction/expiredAction');
